export const Location = {
  All: _TL_('All locations'),
  US: _TL_('United States'),
  GB: _TL_('United Kingdom'),
  CA: _TL_('Canada'),
  DE: _TL_('Germany'),
  FR: _TL_('France'),
  AU: _TL_('Australia'),
  NL: _TL_('Netherlands'),
  CH: _TL_('Switzerland'),
  ES: _TL_('Spain'),
  IT: _TL_('Italy'),
};

export const DefaultLocationOptions = [
  { key: 'All', text: _TL_('All locations') },
];
